
import { CalculatorFormValues } from '../schema';

export function calculateIncomeContribution(data: CalculatorFormValues) {
  const INCOME_CONTRIBUTION_RATE = data.applicantStatus === 'single' ? 0.8 : 0.4;
  
  const totalDeductions = data.incomeTax + data.usc + data.prsi + 
                         data.propertyTax + data.homeLoanInterest + 
                         data.maintenancePayments + data.healthExpenses;
  
  const assessableIncome = Math.max(0, data.grossIncome - totalDeductions);
  const annualIncomeContribution = assessableIncome * INCOME_CONTRIBUTION_RATE;
  
  return annualIncomeContribution;
}
